import { IconPropTypes } from '@/legacy/types';

type ChevronProps = IconPropTypes & {
	dir?: 'up' | 'down';
	size?: number;
};

const BaseChevron = ({
	dir = 'down',
	size = 12,
	strokeWidth = 1.5,
	className,
	color = 'currentColor',
}: ChevronProps) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		viewBox='0 0 12 6'
		width={size}
		height={size / 2}
		fill='none'
		stroke={color}
		strokeWidth={strokeWidth}
		strokeLinecap='round'
		strokeLinejoin='round'
		className={className}
	>
		<path
			d='M1.5 1.5 L6 5 L10.5 1.5'
			transform={dir === 'up' ? 'rotate(180 6 3)' : undefined}
		/>
	</svg>
);

export const ChevronDown = (p: any) => (
	<BaseChevron
		{...p}
		dir='down'
	/>
);
export const ChevronUp = (p: any) => (
	<BaseChevron
		{...p}
		dir='up'
	/>
);
